module.exports = __webpack_public_path__ + "img/4.1d3edd6a.png";